const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for getting data related to a youtube/vimeo link
 * @argument {Application} Application defines the Application service
 * @argument {$q} $q defines the $q service
 * @argument {$http} $http defines the $http service
 */
app.factory('LinkedVideoData', ['Application', 'Authorization', '$http', '$q', function (Application, Authorization, $http, $q) {

  var parseYoutubeDuration = function(item) {
    var temp = '';
    var hours = 0;
    var minutes = 0;
    var seconds = 0;

    if (item.slice(0, 2) !== 'PT') {
      return 0;
    }
    item = item.slice(2);

    for (var i = 0; i < item.length; i++) {
      switch (item[i]) {
        case 'H':
          hours = parseInt(temp) * 3600;
          temp = '';
          break;
        case 'M':
          minutes = parseInt(temp) * 60;
          temp = '';
          break;
        case 'S':
          seconds = parseInt(temp);
          temp = '';
          break;
        default:
          temp += item[i];
          break;
      };
    }

    return hours + minutes + seconds;
  };

  var youtubeKey = '';
  var youtubeData = function(youtubeId){
    return $http.get('integrations/youtube/' + youtubeId).then(function(data) {
      var duration;
      data = data.data.items[0];
      if (data.contentDetails && data.contentDetails.duration) {
        duration = parseYoutubeDuration(data.contentDetails.duration);
      }

      return {
        title: data.snippet.title,
        description: data.snippet.description,
        duration: duration
      }
    });
  };

  var vimeoData = function(vimeoId){
    var url = 'https://vimeo.com/api/v2/video/' + vimeoId + '.json';
    var req = {
      method: 'GET',
      url: url,
      headers: {
        'Remove-auth': true
      }
    };
    return $http(req).then(function(response){
      var data = response.data;
      return {
        title: data[0].title,
        description: data[0].description,
        duration: data[0].duration
      };
    });
  };

  var retrieve = function(id, type){
    switch(type){
      case "youtube":
        return youtubeData(id);
      case "vimeo":
        return vimeoData(id);
    }

    return $q(function(resolve, reject){
      reject("Unknown type specified")
    })
  };

  return {
    retrieve: retrieve
  }
}]);
